import { ActivatedRoute } from '@angular/router';
import { filterMap } from '@interacta-shared/util';
import { Observable } from 'rxjs';
import { PageView, pageViews } from '../models/google-analytics.model';

export function isPageView(value: string): value is PageView {
    const pageViewSet = new Set<string>(pageViews);

    return pageViewSet.has(value);
}

export function getRouteDataId(route: ActivatedRoute): Observable<string> {
    let child = route;
    while (child.firstChild) {
        child = child.firstChild;
    }
    return child.data.pipe(
        filterMap((data) =>
            data['id'] && typeof data['id'] === 'string'
                ? data['id']
                : undefined,
        ),
    );
}
